import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ApplicationStateService } from '../services/application-state.service';
import { ClientEntityManager } from '../entity-system/client-entity-manager.service';
import { PipelineEntityType } from '../../api/datacleanuptool-api.model';

@Injectable()
export class CoursePipelineEntityTypeDataGuard implements CanActivate {

  constructor(
    private entityManager: ClientEntityManager,
    private appState: ApplicationStateService,
  ) {}

  canActivate (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    console.log('programPipelineEntityType data guard invoked :: COURSE');
    this.appState.currentPipelineEntityType = PipelineEntityType.COURSE;
    return true;
  }
}
